document.addEventListener("DOMContentLoaded", () => {
  const giftWrapCheckbox = document.querySelector('.gift_wrap__checkbox');
  const modal = document.createElement('div');
  modal.id = 'gift-wrap-modal';
  modal.style.display = 'none';
  document.body.appendChild(modal);

  const overlay = document.createElement('div');
  overlay.className = 'gift-wrap-modal-overlay';
  overlay.style.display = 'none';
  document.body.appendChild(overlay);

  const closeButton = document.createElement('button');
  closeButton.className = 'close-modal';
  closeButton.innerText = 'X';
  modal.appendChild(closeButton);

  function openModal(content) {
      modal.innerHTML = content;
      modal.style.display = 'block';
      overlay.style.display = 'block';
  }

  function closeModal() {
      modal.style.display = 'none';
      overlay.style.display = 'none';
      giftWrapCheckbox.checked = false;
  }

  const giftWrapInput = document.getElementById('gift_wrap_product');
  const giftWrapFreeInput = document.getElementById('gift_wrap_product_free');
  const giftWrapProductId = giftWrapInput.value;
  const giftWrapProductInfo = {
      title: giftWrapInput.dataset.title,
      price: giftWrapInput.dataset.price,
      image: giftWrapInput.dataset.image
  };

  const giftWrapProductFreeId = giftWrapFreeInput.value;
  const giftWrapProductFreeInfo = {
      title: giftWrapFreeInput.dataset.title,
      price: giftWrapFreeInput.dataset.price,
      image: giftWrapFreeInput.dataset.image
  };

  async function checkGiftInCart() {
      const cart = await fetch('/cart.js').then(res => res.json());
      const productTitle = document.querySelector('.product-title').innerText.trim();

      const giftItem = cart.items.find(item => 
          item.properties && 
          item.properties.Produto === productTitle
      );

      if (giftItem) {
          giftWrapCheckbox.checked = true;
      } else {
          giftWrapCheckbox.checked = false;
      }
  }

  checkGiftInCart();

  giftWrapCheckbox.addEventListener('change', async function () {
      if (this.checked) {
          openModal(
              `<h2>Selecione a Embalagem de Presente</h2>
              <div class="gift-options">
                  <div>
                      <div class="gift-wrap__image">
                          <img src="${giftWrapProductInfo.image}" alt="${giftWrapProductInfo.title}" />
                          <button data-variant-id="${giftWrapProductId}" class="select-gift">Selecionar</button>
                      </div>
                      <p>${giftWrapProductInfo.title}</p>
                      <p>${giftWrapProductInfo.price}</p>
                  </div>
                  <div>
                      <div class="gift-wrap__image">
                          <img src="${giftWrapProductFreeInfo.image}" alt="${giftWrapProductFreeInfo.title}" />
                          <button data-variant-id="${giftWrapProductFreeId}" class="select-gift">Selecionar</button>
                      </div>
                      <p>${giftWrapProductFreeInfo.title}</p>
                      <p>${giftWrapProductFreeInfo.price}</p>
                  </div>
              </div>`
          );

          document.querySelectorAll('.select-gift').forEach(button => {
              button.addEventListener('click', function () {
                  const variantId = this.dataset.variantId;
                  proceedToStepTwo(variantId);
              });
          });
      } else {
          await removeGiftProduct();
      }
  });

  overlay.addEventListener('click', closeModal);
  closeButton.addEventListener('click', closeModal);

  async function proceedToStepTwo(variantId) {
      openModal(
          `<h3>Se houver mais produtos, inclua o nome de cada um com sua respectiva mensagem.</h3>
          <textarea id="gift-message" placeholder="Quer enviar uma mensagem?"></textarea>
          <div class="gift-wrap__checkbox">
              <div>
                  <input type="checkbox" id="leave-blank">
                  <label for="leave-blank">Deixar campo de mensagem em branco para todos produtos</label>
              </div>
              <button id="submit-gift">Enviar</button>
          </div>`
      );

      document.getElementById('submit-gift').addEventListener('click', async function () {
          const message = document.getElementById('gift-message').value;
          const leaveBlank = document.getElementById('leave-blank').checked;

          if (message || leaveBlank) {
              const productTitle = document.querySelector('.product-title').innerText.trim();
              await addGiftProduct(variantId, leaveBlank ? '' : message, productTitle);
              alert('Embalagem adicionada');
              location.reload();
              closeModal();
          } else {
              alert('Por favor, preencha a mensagem ou selecione a opção de deixar em branco.');
          }
      });
  }

  async function addGiftProduct(variantId, message, productTitle) {
      await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              id: variantId,
              quantity: 1,
              properties: {
                  Produto: productTitle,
                  Mensagem: message || '* em branco *'
              }
          })
      });
  }

  async function removeGiftProduct() {
      const cart = await fetch('/cart.js').then(res => res.json());
      const productTitle = document.querySelector('.product-title').innerText.trim();

      const giftItem = cart.items.find(item => 
          item.properties && 
          item.properties.Produto === productTitle
      );

      if (giftItem) {
          await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                  id: giftItem.key,
                  quantity: 0
              })
          });

          alert('Embalagem removida');
          location.reload();
      }
  }
});
